import { render, staticRenderFns } from "./Segmentacao.vue?vue&type=template&id=65eba49f&"
import script from "./Segmentacao.vue?vue&type=script&lang=js&"
export * from "./Segmentacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports